import { useEffect } from "react";
import LoginEntrepriseBloc from "../../../blocs/entreprise/login/LoginEntrepriseBloc";
import LoginEntrepriseCoverBloc from "../../../blocs/entreprise/login/LoginEntrepriseCoverBloc";
import { scroll2Top } from "../../../utils/utils";



export default function LoginEntreprisePage() {
    useEffect(() => {scroll2Top();}, []);

      return (
        <section className="bg-glace p-y-xl">
            <div className="grid bloc-coadherent">
                <LoginEntrepriseCoverBloc/>
                <LoginEntrepriseBloc/>
            </div>
        </section>
    )
}